import { CCUtils } from "../../../common/CCUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { EveryCigBodyPart } from "./EveryCigTypes"

export enum EveryCigPart1Audio {
    CLICK_BODY = "ecd1-n1.mp3",
    TIME_TO_VOTE = "ecd1-n2.mp3",
    CHOOSE_GROSSEST = "ecd1-n3.mp3",
    EVERY_CIG = "ecd1-n4.mp3",
    NEXT_TIME = "ecd1-n5.mp3",
    WARNING = "ecd2-n2.mp3"
}

export enum EveryCigPart2Audio {
    SEE_VOTES_PT2 = "ecd2-n1.mp3"
}

export enum EveryCigImages {
    BACKGROUND = "background.png",
    SKULLNBONES = "skullnbones.png"
}

export enum EveryCigAtlases {
    DROPDOWN_SCREEN = "dropdown-screen.json",
    WARNING_SCREEN = "warning-screen.json"
}

export const everyCigMovieName = (part: string) => `ecd-${part.toLowerCase()}.mp4`
export const everyCigMoviePreviewImage = (part: string) => `${part.toLowerCase()}.jpg`

// tslint:disable-next-line
function loadEveryCigGenericAssets(loader: { atlas, video, image }) {
    CCUtils.enumValues(EveryCigBodyPart).forEach((part: string) => {
        const video = everyCigMovieName(part)
        const preview = everyCigMoviePreviewImage(part)
        loader.video(video, video)
        loader.image(preview, preview)
    })
}

export function loadAssets(game: Phaser.Game, part: 1 | 2) {
    const load = PhaserUtils.makeLoader(game, "every-cig")
    loadEveryCigGenericAssets(load)
    if (part === 1) {
        load.autoLoad({audioEnum: EveryCigPart1Audio, imageEnum: EveryCigImages, atlasEnum: EveryCigAtlases})
    } else {
        load.autoLoad({audioEnum: EveryCigPart2Audio, imageEnum: EveryCigImages, atlasEnum: EveryCigAtlases})
    }
}
